import axiosInstance from "../axios/axios-instance";
import {
  SystemConfigsListParams,
  SystemConfigsListResponse,
  SystemConfigsRequest,
  SystemConfigsResponse,
} from "../@type/SystemConfigs.types";
import { ApiResponse } from "../@type/package.types";
import { pathAPI } from "../utils/pathApi";

export const SystemConfigsService = {
  list: (params: SystemConfigsListParams) => {
    return axiosInstance.get<SystemConfigsListResponse>(pathAPI.systemConfigs, {
      params,
    });
  },

  getById: (id: number) => {
    return axiosInstance.get<ApiResponse<SystemConfigsResponse>>(
      `${pathAPI.systemConfigs}/${id}`
    );
  },

  create: (data: SystemConfigsRequest) => {
    return axiosInstance.post<ApiResponse<SystemConfigsResponse>>(
      pathAPI.systemConfigs,
      data
    );
  },

  update: (id: number, data: SystemConfigsRequest) => {
    return axiosInstance.put<ApiResponse<SystemConfigsResponse>>(
      `${pathAPI.systemConfigs}/${id}`,
      data
    );
  },

  updateStatus: (id: number, status: number) => {
    return axiosInstance.put<ApiResponse<SystemConfigsResponse>>(
      `${pathAPI.systemConfigs}/${id}/status`,
      undefined,
      { params: { status } }
    );
  },

  remove: (id: number) => {
    return axiosInstance.delete(`${pathAPI.systemConfigs}/${id}`);
  },
};
